(function () {
    "use strict";

    angular
        .module('laekkerAI.tablet')
        .component('search', {
            controller: 'TabletSearchController',
            templateUrl:  '/components/search/search.html',
            bindings: {
                onChange: '&',
                value: '<'
            }
        });
}());